import React from 'react'
import { useNavigate } from 'react-router-dom'
import AsideBar from './AsideBar'
import BottomMenu from './BottomMenu'

export default function LoginRequired({ message = 'To continue, please login to your account.', withSidebar = true }) {
  const navigate = useNavigate()

  const card = (
    <div className='d-flex flex-column align-items-center justify-content-center text-center' style={{ minHeight: '60vh' }}>
      <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'linear-gradient(135deg, #008ad8 0%, #0056b3 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', boxShadow: '0 8px 24px rgba(0,138,216,0.3)' }}>
        <svg width='36' height='36' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z' fill='white' />
          <path d='M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z' fill='white' />
        </svg>
      </div>
      <h3 className='fw-bold mb-2' style={{ color: '#1a1a2e' }}>Login Required</h3>
      <p className='text-muted mb-4' style={{ maxWidth: '300px', lineHeight: '1.6', fontSize: '15px' }}>
        {message}
      </p>
      <button
        className='btn btn-primary rounded-pill px-5 py-2 fw-bold'
        style={{ background: 'linear-gradient(135deg, #008ad8 0%, #0056b3 100%)', border: 'none', fontSize: '16px', boxShadow: '0 4px 16px rgba(0,138,216,0.35)' }}
        onClick={() => navigate('/send-otp')}
      >
        Login
      </button>
    </div>
  )

  if (!withSidebar) {
    return (
      <section className='wrapper pb-5' style={{ minHeight: '80vh' }}>
        <div className='container'>{card}</div>
      </section>
    )
  }

  return (
    <section className='wrapper-asidecontent'>
      <div className='container pb-md-4 pb-3'>
        <div className='row pt-md-4 pt-3'>
          <div className='col-auto d-none d-lg-block'>
            <AsideBar />
          </div>
          <div className='col pt-md-3 pt-1 profile-wrapper'>{card}</div>
        </div>
        <BottomMenu />
      </div>
    </section>
  )
}
